<template>
  <div id="app" class="site container hfeed" style="height: auto !important">
    <!-- 顶部导航 -->
    <HeadNav selectedLanguage="en" page="fm" />

    <div class="features-section features-bgList">
<!-- 头部横向布局 -->
      <div class="fm-header">
        <img class="fm-logo" src="@/assets/fm.webp" alt="FM WhatsApp" />
        <div class="fm-header-right">
          <h1 class="intro-title header-title">FM WhatsApp APK Download (Latest Version 2026) – Updated &amp; Safe MOD</h1>
          <div class="badge-list header-badges">
            <span>🛡️ Secured</span>
            <span>✔️ Certified</span>
            <span>✨ Top Rated</span>
          </div>
          <button class="free-download-btn header-download" @click="goDownload">Download FM WhatsApp</button>
        </div>
      </div>

      <!-- 简介段落 -->
      <p class="desc">
        Tired of WhatsApp's basic features? <strong>FM WhatsApp</strong> is the perfect alternative for users who want more control,
        customization, and privacy. With FM WhatsApp APK, you can hide online status, freeze last seen, use custom themes, and send
        larger media files with ease.
      </p>
      <p class="desc">
        Download FM WhatsApp APK safely from our site, where we provide verified, malware-free files. We ensure the latest, secure
        versions for a smooth experience. Avoid risks by choosing trusted sources like ours. Enjoy enhanced features with peace of
        mind—only download FM WhatsApp APK safely from our trusted platform.
      </p>

      <!-- 规格表 -->
      <h2 class="intro-title">FM WhatsApp – Specifications</h2>
      <div class="figure-table">
        <figure class="wp-block-table">
          <table>
            <thead>
              <tr>
                <th>Item</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>App Name</td>
                <td>FM WhatsApp</td>
              </tr>
              <tr>
                <td>Version</td>
                <td>2026 Latest (v9.90+)</td>
              </tr>
              <tr>
                <td>Size</td>
                <td>70-80 MB</td>
              </tr>
              <tr>
                <td>Developer</td>
                <td>Fouad Mokdad</td>
              </tr>
              <tr>
                <td>Required Android</td>
                <td>5.0 and Above</td>
              </tr>
              <tr>
                <td>Last Updated</td>
                <td>Recently (2026)</td>
              </tr>
            </tbody>
          </table>
        </figure>
      </div>

      <!-- 什么是 FM WhatsApp -->
      <h2 class="intro-title">What Is FM WhatsApp and Why Should You Use It?</h2>
      <p class="desc">
        <strong>FM WhatsApp</strong> is a popular modified version (MOD) of the official WhatsApp Messenger, offering additional
        features and customization options not found in the original app. Developed by Fouad Mokdad, FM WhatsApp aims to enhance
        the user experience by providing advanced privacy settings, a variety of themes, and extended functionalities such as
        message scheduling, hiding last seen, and much more.
      </p>
      <p class="desc">
        People choose FM WhatsApp because it allows greater control over their messaging app's appearance and behavior while
        retaining core WhatsApp functionalities. Whether you want to customize the interface, increase file sharing limits, or
        improve privacy, FM WhatsApp offers these extras in a user-friendly package.
      </p>

      <!-- 下载部分 -->
      <h2 class="intro-title">Download FM WhatsApp APK (Latest 2026 Version)</h2>
      <ol class="download-steps">
        <li>Enable "Unknown Sources" in your Android device settings under Security.</li>
        <li>Download the FM WhatsApp APK file from a reliable website.</li>
        <li>Tap the APK file and follow the installation prompts.</li>
        <li>Once installed, open FM WhatsApp and register with your phone number.</li>
      </ol>
      <div class="download-btn-wrapper">
        <button class="free-download-btn" @click="goDownload">Download FM WhatsApp APK</button>
      </div>

      <!-- 特色列表 -->
      <h2 class="intro-title">Top Features of FM WhatsApp MOD APK</h2>
      <ul class="feature-list">
        <li>Custom Themes: Choose from thousands of themes to change your app's look and feel.</li>
        <li>Privacy Options: Hide last seen, blue ticks, second ticks, typing status, and recording indicators.</li>
        <li>Message Scheduler: Schedule messages to be sent automatically at a set time.</li>
        <li>Increased Limits: Send larger files, videos, and high-quality images without compression.</li>
        <li>Anti-Delete Messages: View messages and statuses even if the sender deletes them.</li>
        <li>Multiple Accounts: Use multiple WhatsApp accounts on the same device.</li>
        <li>Enhanced Media Sharing: Share up to 100 images at once (official WhatsApp allows 30).</li>
        <li>Pin More Chats: Pin up to 100 chats for easy access.</li>
        <li>DND Mode: Disable internet for FM WhatsApp only without affecting other apps.</li>
      </ul>

      <!-- 与官方比较标题占位，可补充图表 -->
      <h2 class="intro-title">FM WhatsApp vs Official WhatsApp: Key Differences</h2>
      <!-- 可以在此插入图表或图片，当前留空以便后续补充 -->

      <!-- 安装指南 -->
      <h2 class="intro-title">How to Install FM WhatsApp on Android Devices</h2>
      <ol class="install-steps">
        <li>Backup WhatsApp Chats (if currently using official WhatsApp).</li>
        <li>Enable Unknown Sources: Settings > Security > Unknown Sources > Enable.</li>
        <li>Download the FM WhatsApp APK from our trusted source.</li>
        <li>Locate the downloaded APK file and tap it.</li>
        <li>Follow on-screen instructions to install.</li>
        <li>Open FM WhatsApp, verify your phone number, and restore backup if available.</li>
        <li>Customize settings and enjoy the new features!</li>
      </ol>

      <!-- 新功能 -->
      <h2 class="intro-title">FM WhatsApp Latest Version – What's New in 2026?</h2>
      <ul class="feature-list">
        <li>Improved user interface with more intuitive navigation.</li>
        <li>Enhanced privacy options with more granular control.</li>
        <li>Increased file size limit to 1GB for video and audio sharing.</li>
        <li>New animation effects for chats and themes.</li>
        <li>Optimized battery usage for longer app run-time.</li>
        <li>Bug fixes and stability improvements.</li>
        <li>Integration with cloud backup options for easier data recovery.</li>
      </ul>

      <!-- 安全性与合法性 -->
      <h2 class="intro-title">Is FM WhatsApp Safe and Legal to Use?</h2>
      <p class="desc">
        While FM WhatsApp is popular for its extended features, it is not an official WhatsApp product and is developed by third
        parties. This means it may pose security risks since the code is not audited by WhatsApp or major security firms. Use FM
        WhatsApp cautiously and always download APKs only from trusted sources.
      </p>

      <!-- 兼容性要求 -->
      <h2 class="intro-title">FM WhatsApp Compatibility and Requirements</h2>
      <ul class="feature-list">
        <li>Android Version: Compatible with Android 5.0 (Lollipop) and above.</li>
        <li>Storage: Minimum 100MB free storage recommended for smooth operation.</li>
        <li>Internet: Requires active internet connection (Wi-Fi or mobile data).</li>
        <li>Device: Works on most Android smartphones and tablets. Not available for iOS devices.</li>
        <li>Permissions: Requires access to contacts, storage, microphone, camera, and more for full functionality.</li>
      </ul>

      <!-- 常见问题 -->
      <h2 class="intro-title">FAQs – Everything You Need to Know About FM WhatsApp</h2>
      <div class="faq-list">
        <p><strong>Q1: Can I use FM WhatsApp with my current WhatsApp number?</strong><br />Yes, but it's recommended to backup your chats before switching.</p>
        <p><strong>Q2: Will I get banned from WhatsApp if I use FM WhatsApp?</strong><br />There is a risk of getting banned from WhatsApp if you use FM WhatsApp. However, if you download a clean and virus-free APK from a trusted source, it is generally safer to use. Always be cautious and back up your data regularly to avoid issues.</p>
        <p><strong>Q3: How do I update FM WhatsApp?</strong><br />Updates are manual; download the latest APK from trusted sources when available.</p>
        <p><strong>Q4: Is FM WhatsApp available for iPhone?</strong><br />No, FM WhatsApp is only available for Android devices.</p>
        <p><strong>Q5: Can I use FM WhatsApp and official WhatsApp simultaneously?</strong><br />Yes, you can run both apps with different phone numbers on the same device.</p>
      </div>

      <!-- 结论 -->
      <h2 class="intro-title">Final Thoughts – Should You Switch to FM WhatsApp in 2026?</h2>
      <p class="desc">
        FM WhatsApp offers exciting features and customization options that many users crave, surpassing the limitations of the
        official WhatsApp. However, with increased functionality comes potential security and privacy risks, and the possibility
        of being banned by WhatsApp. If you prioritize customization and extra features and are comfortable with the risks, FM
        WhatsApp is worth trying in 2026. For users who prioritize security and official support, sticking with the official
        WhatsApp is advisable.
      </p>

      <!-- 再次下载按钮 -->
      <div class="download-btn-wrapper">
        <button class="free-download-btn" @click="goDownload">Download FM WhatsApp</button>
      </div>
    </div>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'FmWhatsappDownload',
  data() {
    return {
      pageName: 'fm-whatsapp',
      apk: null,
      from: 'fm',
      filename: 'fm',
    };
  },
  components: {
    HeadNav},
  mounted() {
    // 如果 query 中含有推广参数则调接口获取 apk
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          if (res.code === 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          if (res.code === 200) {
            if (type === 1) {
              this.apk = res.data.apk;
            }
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    goDownload() {
      console.log('ssssssssss',this.apk);
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.intro-title {
  font-weight: 700;
  font-size: 25px;
  padding: 10px 0;
  text-align: left;
}

.badge-list {
  display: flex;
  padding-left: 18px;
  margin: 10px 0 20px;
  span {
    display: inline-block;
    margin-right: 15px;
    font-weight: 600;
    color: #1697BB;
  }
}

.free-download-btn {
  background-color: #1697BB;
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  margin: 10px 5px;
}

.desc {
  margin: 10px 0;
  line-height: 1.6;
  text-align: left;
}

.feature-list,
.download-steps,
.install-steps {
  padding-left: 20px;
  margin: 10px 0;
  text-align: left;
}

.feature-list {
  list-style-type: disc;
}

.download-steps,
.install-steps {
  list-style-type: decimal;
}

.feature-list li,
.download-steps li,
.install-steps li {
  text-align: left;
}

.faq-list p {
  margin: 10px 0;
  text-align: left;
}

.fm-img-wrapper {
  text-align: center;
  margin: 20px 0;
  img {
    max-width: 320px;
    width: 100%;
  }
}

.fm-header {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
  justify-content: center;
}

.fm-logo {
  width: 170px;
  height: 170px;
  object-fit: contain;
}

.fm-header-right {
  width: 700px;
}

.header-badges span {
  display: inline-flex;
  align-items: center;
  margin-right: 15px;
  font-weight: 600;
  color: #1697BB;
}

.header-download {
  margin-top: 10px;
  width: 100%;
}

.header-title {
}

@media (max-width: 768px) {
  .fm-header {
    flex-direction: column;
    align-items: center;
  }
  .fm-logo {
    width: 60px;
    height: 60px;
  }
}
</style> 